import { useState } from 'react';
import { Button, Input, Modal } from '../../../../shared/ui';
import { CreatePropertyData } from '../../../../shared/utils';
import './AddressPromptModal.css';

interface AddressPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: CreatePropertyData) => Promise<void>;
  loading: boolean;
}

const EMPTY_FORM: CreatePropertyData = {
  label: 'My Home',
  streetName: '',
  houseNumber: '',
  pinCode: '',
  city: '',
  state: '',
  country: '',
  isPrimary: true,
};

export const AddressPromptModal = ({
  isOpen,
  onClose,
  onSave,
  loading,
}: AddressPromptModalProps) => {
  const [formData, setFormData] = useState<CreatePropertyData>(EMPTY_FORM);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSave(formData);
  };

  const footer = (
    <>
      <Button
        type="button"
        variant="outlined"
        onClick={onClose}
        disabled={loading}
      >
        Fill Later
      </Button>
      <Button type="submit" form="address-prompt-form" disabled={loading}>
        {loading ? 'Saving...' : 'Save Address'}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add Your Property Address"
      footer={footer}
      closeOnBackdropClick={false}
    >
      <div className="address-prompt__body">
        <p className="address-prompt__description">
          Help us personalise your experience by adding your property address.
          You can update or add more addresses anytime from your profile.
        </p>

        <form id="address-prompt-form" onSubmit={handleSubmit}>
          <div className="address-prompt__body">
            <Input
              label="Property Label"
              name="label"
              value={formData.label}
              onChange={handleChange}
              placeholder="e.g. Main Home, Holiday Flat"
              required
              fullWidth
            />
            <div className="address-prompt__form-row">
              <Input
                label="Street Name"
                name="streetName"
                value={formData.streetName ?? ''}
                onChange={handleChange}
              />
              <Input
                label="House Number"
                name="houseNumber"
                value={formData.houseNumber ?? ''}
                onChange={handleChange}
              />
            </div>
            <div className="address-prompt__form-row">
              <Input
                label="PIN Code"
                name="pinCode"
                value={formData.pinCode ?? ''}
                onChange={handleChange}
              />
              <Input
                label="City"
                name="city"
                value={formData.city ?? ''}
                onChange={handleChange}
              />
            </div>
            <div className="address-prompt__form-row">
              <Input
                label="State"
                name="state"
                value={formData.state ?? ''}
                onChange={handleChange}
              />
              <Input
                label="Country"
                name="country"
                value={formData.country ?? ''}
                onChange={handleChange}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
